const header = document.getElementById("site-header");

window.addEventListener("scroll", function(){

if(header && header.dataset.sticky === "true"){

if(window.scrollY > 80){

header.classList.add("header-sticky");
header.classList.remove("header-transparent");

}else{

header.classList.remove("header-sticky");

if(header.dataset.transparent === "true"){
header.classList.add("header-transparent");
}

}

}

});

const toggle = document.getElementById("mobileToggle");
const mobileMenu = document.getElementById("mobileMenu");
const closeBtn = document.getElementById("mobileClose");

if(toggle && mobileMenu){
toggle.addEventListener("click", function(){
mobileMenu.classList.add("open");
});
}

if(closeBtn && mobileMenu){
closeBtn.addEventListener("click", function(){
mobileMenu.classList.remove("open");
});
}
